export const getCleanedUrlParams = (
  urlParam: string | undefined | null,
): string | undefined =>
  urlParam === undefined || urlParam === null || urlParam === "undefined"
    ? undefined
    : urlParam;
